import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslations } from "@bsm/component";

export const StudentProxyContainer = () => {

    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const [
        PROXY_CONTACT,
        FAMILY_NAME,
        FIRST_NAMES,
        PHONE_NUMBERS,
        EMAIL,
    ] = useTranslations(i18nKeys);

    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={PROXY_CONTACT} className="flex flex-col gap-3 p-10">
                <Metadata label={FAMILY_NAME} value={data.proxyContact?.familyName} />
                <Metadata label={FIRST_NAMES} value={data.proxyContact?.firstName} />
                <Metadata label={PHONE_NUMBERS} value={data.proxyContact?.phones} />
                <Metadata label={EMAIL} value={data.proxyContact?.email} />
            </Box>
        </div>
    );
}

const i18nKeys = [
    "std_proxy_contact",
    "std_family_name",
    "std_first_names",
    "std_phone_numbers",
    "std_email"  
];
